import styled from 'styled-components';
import { RawButton } from '../../../../CommonComponents/OPL/Button/Button.styles';

export const StyledButton = styled(RawButton)(({ theme }) => ({
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.colors.bg,
  borderWidth: '1px 0',
  borderStyle: 'solid',
  borderColor: theme.colors.neutral[200],
  borderRadius: 0,

  '&:hover': {
    backgroundColor: theme.colors.neutral[100],
  },
}));
